import { render, staticRenderFns } from "./ueditorDialog.vue?vue&type=template&id=326286c2&scoped=true"
import script from "./ueditorDialog.vue?vue&type=script&lang=js"
export * from "./ueditorDialog.vue?vue&type=script&lang=js"
import style0 from "./ueditorDialog.vue?vue&type=style&index=0&id=326286c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326286c2",
  null
  
)

export default component.exports